<template>
  <div class="publishers">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" color="#fff">
        <use xlink:href="#icon-Publishers-"></use>
      </svg>
    </breadcrumbs>

    <!-- 将 a-tour 移到这里，作为独立的组件 -->
    <a-tour :arrow="true" :open="open" :steps="steps" @close="handleOpen(false)" placement="bottom">
      <!-- <template #indicatorsRender="{ current, total }">
        <span>{{ current + 1 }} / {{ total }}</span>
      </template> -->
    </a-tour>

    <a-spin :spinning="loading">
      <div class="table">
        <div class="table-head">
          <div class="table-left">
            <a-space>
              <ButtonGroups :pagination="pagination" :tableData="dataSource" @pageChange="onPageChange" />
            </a-space>
            <a-input-search v-model:value="queryParams.keywords" :placeholder="$t('seller.common.searchPlaceholder')"
              allow-clear @search="onSearch" @enter="onSearch">
            </a-input-search>
          </div>
          <div class="filter-item" style="margin-bottom: 0px;">
            <!-- <artmisads-button-special @click="setShowUpdateProductModal">
            <svg class="icon shangchuan2" aria-hidden="true">
              <use xlink:href="#icon-shangchuan2"></use>
            </svg>
            <span class="btn-text">Bulk Create Partnerships</span>
          </artmisads-button-special>  -->
          </div>

        </div>

        <div class="filters">
          <div class="filter-item" ref="statusFilter">
            <div class="label">
              {{ $t('seller.brandsPage.colPromotionCountries') }}
            </div>
            <div class="checkbox" ref="countryRef">
              <artmisads-select style="width: 232px;"
               class="country" 
               v-model:value="filter.promotionCountry"
               :placeholder="$t('seller.common.promotionCountries')"
                :options="countries"  
                :show-search="false"
                :allowClear="true"
              :getPopupContainer="() => $refs.countryRef">
                
              </artmisads-select>
             
            </div>
          </div>
          <div class="filter-item">
            <div class="label">
              {{ $t('seller.publishersPage.filterPromotionMethod') }}
            </div>
            <div class="checkbox" ref="methodRef">
             <a-select style="width: 232px;" 
             v-model:value="filter.promotionMethodId"
              :placeholder="$t('seller.common.promotionMethod')"
               :show-search="false"
                :allowClear="true"
              :options="methods"
              :getPopupContainer="() => $refs.methodRef"
              >
            </a-select>
            </div>
          </div>
          <div class="filter-item">
            <div class="label">
              {{ $t('seller.brandsPage.colProductCategories') }}
            </div>
            <div class="checkbox" ref="categoryRef">
              <artmisads-select
               style="width: 232px;" 
                v-model:value="filter.promotionProductCategoryId"
                :placeholder="$t('seller.common.promotionCategories')"
                :show-search="false"
                :allowClear="true"
                :options="categories"
                :getPopupContainer="() => $refs.categoryRef"
                />
            </div>
          </div>

        </div>
        <div class="table-body" v-if="dataSource.length > 0">
          <div class="publisher-grid">
            <publisherTable :showAssociatePartnership="true" :dataSource="dataSource" ref="publisherTableRef"
              @refresh='getList' />
          </div>
          <div class="pagination-container">
            <a-pagination class="pagination" show-less-items @change="setPage" :total="pagination.total"
              :pageSize="pagination.size" :showSizeChanger="true" v-model:current="pagination.page"
              :pageSizeOptions="['10', '20', '30', '50', '100']" @showSizeChange="(c, size) => setFilter('size', size)">
              <template #buildOptionText="opt">
                <span>{{ $t('seller.publishersPage.perPage', { n: opt.value }) }}</span>
              </template>
              <template #itemRender="{ type, originalElement }">
                <a v-if="type === 'prev'">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-jiantou-zuo-cu"></use>
                  </svg>
                </a>
                <a v-else-if="type === 'next'">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-jiantou-you-cu"></use>
                  </svg>
                </a>
                <component :is="originalElement" v-else></component>
              </template>
            </a-pagination>
          </div>

        </div>
        <no-data v-if="dataSource.length == 0 && !loading" />

      </div>
    </a-spin>
    <setPartnershipMultiple ref="setPartnershipMultipleRef" @refresh='getList' />
  </div>
</template>

<script setup>
import i18n from '~/i18n'

import { ref, onMounted,watch, onUnmounted, createVNode, inject, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import breadcrumbs from '../breadcrumbs.vue'
import ButtonGroups from '@/components/buttonGroups.vue'
import publisherTable from './components/publisherTable.vue'
import { publishersApi } from '@/server'
import { message } from 'ant-design-vue'
import NoData from '~/components/NoData.vue'
import { useRoute } from 'vue-router'
import { useUserInfoStore } from '~/storeData/index'
import jwt from 'jsonwebtoken'
import { adminApi } from '~/server/index'
import setPartnershipMultiple from '~/components/setPartnershipMultiple.vue'
import { COUNTRY_BASE } from '~/contants/common'
import Icon from '~/components/Icon.vue'
import profileApi from '~/server/register'
const categories = ref([])
const countries = ref([])
const methods = ref([])
const { t } = useI18n()
const store = useUserInfoStore()
const checked = ref(false)
const setPartnershipMultipleRef = ref(null)
// 注入 leftMenuRef
const filter = ref({
  associateBrandProgress: 'All',
  promotionProductCategoryId: '',
  promotionMethodId: '',
  promotionCountry: '',
})
watch(filter, (newVal) => {
  pagination.value.page = 1
  getList()
}, { deep: true })
const leftMenuRef = inject('leftMenuRef')
const route = useRoute()
const breadcrumbsData = computed(() => ({
  title: t('seller.menu.publishers'),
  hasTitleIcon: true,
  color: '#80C026',
  links: [
    {
      name: t('seller.common.home'),
      path: '/seller/dashboard'
    },
    {
      name: t('seller.menu.publishers'),
      path: '/seller/publishers'
    }
  ]
}))
const partnershipSegmentOptions = computed(() => [
  { label: t('seller.common.all'), value: 'All' },
  { label: t('seller.brandsPage.partnershipPartnered'), value: 'Partnered' },
  { label: t('seller.brandsPage.partnershipNotPartnered'), value: 'Not Partnered' },
])
const pagination = ref({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  page: 1,
  showSizeChanger: true,
  pageSize: 10
})
const loading = ref(false)
const queryParams = ref({
  associateBrandProgress: 'All',
  associateEnable: 'Off'
})
const dataSource = ref([

])
async function init() {
      const p1 = await profileApi.getPromotionProductCategories().then(res => {
          categories.value = res.data.map(item => {
              return {
                  label: item.name,
                  value: item.id
              }
          })
          categories.value.unshift({
            label: t('seller.common.all'),
            value: ''
          })
      });
      const p2 = await profileApi.getPromotionCountriesSeller().then(res => {
          countries.value = res.data.map(item => {
              return {
                  label: item.name,
                  value: item.code
              }
          })
          countries.value.unshift({
            label: t('seller.common.all'),
            value: ''
          })
         
      });
      const p3 = await profileApi.getPromotionMethods().then(res => {
          methods.value = res.data.map(item => {
              return {
                  label: item.name,
                  value: item.id
              }
          })
          methods.value.unshift({
            label: t('seller.common.all'),
            value: ''
          })
      });
      Promise.all([p1, p2, p3])
  }
const handleChange = (value) => {
  if (value === 'Partnered' || value === 'Not Partnered') {
    checked.value = true
  }
  pagination.value.page = 1
  getList()
}
const handleChangeAssociateEnable = (value) => {
  if (checked.value === false) {
    filter.value.associateBrandProgress = 'All'
  }
  pagination.value.page = 1
  getList()
}

const getList = async () => {
  loading.value = true
  try {
    const res = await publishersApi.getPublishers({
      page: pagination.value.page,
      size: pagination.value.size,
      keyword: queryParams.value.keywords,
      promotionProductCategoryId: filter.value.promotionProductCategoryId,
      promotionMethodId: filter.value.promotionMethodId,
      promotionCountry: filter.value.promotionCountry,
      // associateBrandProgress: filter.value.associateBrandProgress === 'Partnered' ? '1' : filter.value.associateBrandProgress === 'Not Partnered' ? '0' : undefined,
      // associateEnable: !checked.value ? undefined : '1'
    })
    if (res.success) {
      dataSource.value = res.data?.data?.map(item => ({
        ...item.publisherVO,
        associateBrandCount: item.associateBrandCount
      }))
      dataSource.value?.forEach(item => {
        if (item?.links) {
          item.links = item?.links?.filter(link => {
            return link.url
          })
        }
      })
      pagination.value.total = res.data.total
    } else {
      message.error(res.error)
    }
  } catch (error) {
    console.error('获取数据失败:', error)
    message.error(i18n.global.t('seller.msg.getDataFailed'))
  } finally {
    loading.value = false
  }
}
const associateProgramRef = ref(null)
const publisherTableRef = ref(null)
const open = ref(false)
const statusFilter = ref(null)
const steps = computed(() => [
  {
    title: t('seller.publishersPage.tourTitle'),
    description: t('seller.publishersPage.tourStep1Desc'),
    target: () => {
      if (leftMenuRef.value) {
        return leftMenuRef.value.getMenuItemElement('Publishers')
      }
      return null
    },
    placement: 'right',
  },
  {
    title: t('seller.publishersPage.tourTitle'),
    description: createVNode('div', {
      class: 'tour-cover',
    }, [
      createVNode('div', { class: 'tour-title' }, t('seller.publishersPage.tourStep2Lead')),
      createVNode('div', { class: 'tour-item' }, t('seller.publishersPage.tourStep2At')),
      createVNode('div', { class: 'tour-item' }, t('seller.publishersPage.tourStep2As')),
    ]),
    target: () => {
      if (publisherTableRef.value) {
        const refs = publisherTableRef.value.getAllAssociateProgramRefs()
        if (refs && refs.length > 0) {
          return refs[0]
        }
      }
      return associateProgramRef.value
    },
    placement: 'bottom',
  },
  {
    title: t('seller.publishersPage.tourTitle'),
    description: t('seller.publishersPage.tourStep3Desc'),
    target: () => {
      return statusFilter.value
    },
    placement: 'left',
  }
])
const handleOpen = async (value) => {
  open.value = value

  // 当漫游导航打开时，阻止页面滚动
  if (value) {
    // 添加CSS类来阻止滚动
    document.body.classList.add('tour-active')

    // 阻止页面滚动
    const preventScroll = (e) => {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      return false
    }

    // 添加滚动事件监听器到document
    const scrollEvents = ['wheel', 'scroll', 'touchmove', 'touchstart', 'touchend', 'touchcancel']
    scrollEvents.forEach(eventType => {
      document.addEventListener(eventType, preventScroll, { passive: false, capture: true })
    })

    // 存储事件监听器引用，以便后续移除
    window.tourScrollListeners = scrollEvents.map(eventType => {
      return { eventType, handler: preventScroll }
    })
  } else {
    // 当漫游导航关闭时，移除事件监听器
    document.body.classList.remove('tour-active')

    if (window.tourScrollListeners) {
      window.tourScrollListeners.forEach(({ eventType, handler }) => {
        document.removeEventListener(eventType, handler, { capture: true })
      })
      window.tourScrollListeners = null
    }
    const res = await adminApi.associatePublisherCompleted()
    const { success, error, data } = res
    if (success) {
      const userToken = data.token
      const userInfo = jwt.decode(userToken)
      const menus = store.userInfo.menus
      store.setUserInfo(userInfo, userToken, menus)
    } else {
      message.error(error)
    }
  }
}

const setShowUpdateProductModal = (value) => {
  // setPartnershipMultipleRef.value.show()
  window.open(`/seller/associateCentral/setUpAssociatePartnershipMultiple?isAcc=false`)

}


// 更新分页配置
// setTimeout(() => {
//   setPartnershipMultipleRef.value.show()
// }, 0)
const onPageChange = (page, pageSize) => {
  pagination.value.page = page
  pagination.value.pageSize = pageSize
  getList()


}
const onSearch = (value) => {
  queryParams.value.keywords = value
  pagination.value.page = 1
  pagination.value.size = 10
  getList()
}
const setParams = (params) => {
  pagination.value.page = 1
  queryParams.value.associateBrandProgress = params.associateBrandProgress
  queryParams.value.associateEnable = params.associateEnable
  getList()
}
const setPage = (page, pageSize) => {
  pagination.value.page = page
  pagination.value.size = pageSize
  getList()
}
const setFilter = (key, value) => {
  pagination.value[key] = value
}
onMounted(() => {
  const { isFirst } = route.query
  if (isFirst) {
    queryParams.value.associateEnable = 'ON'
  }
  init()
  getList().then(() => {
    // 数据加载完成后，延迟调试
    setTimeout(() => {
      if (isFirst) {
        if (store.userInfo.associatePublisherCompleted === 'N') {
          handleOpen(true)
        }
      }
    }, 0)
  })
})

// 组件卸载时清理事件监听器
onUnmounted(() => {
  if (window.tourScrollListeners) {
    window.tourScrollListeners.forEach(({ eventType, handler }) => {
      document.removeEventListener(eventType, handler, { capture: true })
    })
    window.tourScrollListeners = null
  }
})
</script>



<style>
.ant-tour-arrow::before {
  clip-path: path('M 0 8 A 4 4 0 0 0 2.82842712474619 6.82842712474619 L 6.585786437626905 3.0710678118654755 A 2 2 0 0 1 9.414213562373096 3.0710678118654755 L 13.17157287525381 6.82842712474619 A 4 4 0 0 0 16 8 Z') !important;
}

/* 当漫游导航激活时，阻止页面滚动 */
body.tour-active {
  overflow: hidden !important;
  height: 100vh !important;
  touch-action: none !important;
  -webkit-overflow-scrolling: touch !important;
  position: fixed !important;
  width: 100% !important;
}
</style>
<style scoped lang="less">
@import '~/assets/less/pagination.less';

.publishers {
  padding: 16px;
  padding-top: unset;
  position: relative; // 添加相对定位

  // 当漫游导航打开时，阻止页面滚动
  &.tour-active {
    overflow: hidden;
    height: 100vh;
    touch-action: none;
    -webkit-overflow-scrolling: touch;
  }
}


.add-publisher-btn {
  cursor: pointer;
  padding: 8px 16px;
  background: #1890ff;
  color: white;
  border-radius: 6px;
  border: none;
  font-size: 14px;

  &:hover {
    background: #40a9ff;
  }
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.table {
  border-radius: var(--Radius-Radius-8, 8px);
  background: #FFF;
  box-shadow: 0 1px 0 0 #0f06290d, 0 2px 8px 0 #00000014;
  padding: 0 16px;
  // border: 2px solid #E8E5ED;
}

.publisher-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;

  // 1920px及以上显示2列
  @media (min-width: 1920px) {
    grid-template-columns: 1fr 1fr;
  }

  .publisher-item {
    width: 100% !important;
  }
}

.filters {
  display: flex;
  gap: 22px;
  padding: 15px 16px;
  margin: 16px 0;

  border-radius: 8px;
  background: #F8F7FC;

  .filter-item {
    .label {

      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      opacity: 0.9;
    }
  }

  .checkbox {
    // display: flex;
    // height: 32px;
    // padding: 0 8px;
    // align-items: center;
    // gap: 10px;
    // border-radius: 8px;
    // background: #EAE8F0;
    margin-top: 6px;
  }

  .statusFilter {
    width: 135px;
    // position: relative;
    z-index: 2;
    // margin-left: 18px;
    // opacity: 0.7;
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-2);
    letter-spacing: 0.4px;
    line-height: 20px;
  }
}

.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--Color-family-Gray-Gray-_5divider, #E8E5ED);

  .table-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

}
</style>